import {
  Container,
  ImageContainer,
  PreviewImg,
  StyledTechDiv,
  InfoContainer,
  Title,
  Description,
  User,
} from './ArticleCard.styles';
import { UserIcon, TimeIcon } from '@/icons/index';
import Link from 'next/link';
import dateToString from '@/utils/dateToString';

interface IArticleCard {
  author: string;
  category: string;
  postDate: string;
  title: string;
  description: string;
  preview: string;
  alt: string;
  slug: string;
}

const ArticleCard = (props: IArticleCard) => {
  const { title, description, category, author, preview, alt, postDate, slug } =
    props;
  return (
    <Link href={`/blog/${slug}`} passHref>
      <Container>
        <ImageContainer>
          <PreviewImg src={preview} alt={alt} />
        </ImageContainer>
        <InfoContainer>
          <StyledTechDiv>{category}</StyledTechDiv>
          <Title>{title}</Title>
          <Description>{description}</Description>
          <User>
            <p>
              <UserIcon />
              {author}
            </p>
            <p>
              <TimeIcon />
              {dateToString(postDate)}
            </p>
          </User>
        </InfoContainer>
      </Container>
    </Link>
  );
};

export default ArticleCard;
